import CurrencyPairPage from './CurrencyPairPage';

export default CurrencyPairPage;
